import { useLocation } from 'react-router-dom'

export const useGetQueryParam = (queryParamName: string) =>
  new URLSearchParams(useLocation().search).get(queryParamName)
